import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Countries } from 'src/app/app.consts';
import { UnsubscribeApiService } from 'src/app/services/api/unsubscribe-api.service';
import { phoneNumberValidator } from 'src/app/validators/phoneNumber';
import { environment } from 'src/environments/local/environment';

@Component({
  selector: 'app-sms-unsubscribe',
  templateUrl: './sms-unsubscribe.component.html',
  styleUrls: ['./sms-unsubscribe.component.scss'],
})
export class SmsUnsubscribeComponent implements OnInit, OnDestroy {
  unsubscribeForm!: FormGroup;
  error: string = '';
  subs = Array<Subscription>();
  isLoading: boolean = false;
  success: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private unsubscribeApi: UnsubscribeApiService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (
      environment.country === Countries.FINLAND ||
      environment.country === Countries.NETHERLANDS
    ) {
      this.router.navigate(['basic-info']);
    }

    this.unsubscribeForm = this.formBuilder.group({
      phoneNumber: ['', [Validators.required, phoneNumberValidator()]],
    });
  }

  handleButtonClick(): void {
    if (this.form.invalid) {
      return;
    }
    this.isLoading = true;

    this.subs.push(
      this.unsubscribeApi.unsubscribeSms(this.phoneNumber.value).subscribe(
        () => {
          this.success = true;
          this.error = '';
          this.isLoading = false;
        },
        (_error: any) => {
          this.error = this.translateService.instant(
            'unsubscribe.unsubscribed.failure'
          );
          this.isLoading = false;
        }
      )
    );
  }

  get form(): FormGroup {
    return this.unsubscribeForm;
  }

  get phoneNumber(): FormControl {
    return this.form.get('phoneNumber') as FormControl;
  }

  getErrors(control: string): string | null {
    const phoneNumber = this.phoneNumber;

    switch (control) {
      case 'phoneNumber':
        if (phoneNumber.hasError('required')) {
          return this.translateService.instant(
            'global.error.phoneNumberRequired'
          );
        } else if (
          phoneNumber.hasError('invalidPhoneNumber') ||
          phoneNumber.invalid
        ) {
          return this.translateService.instant(
            'global.error.phoneNumberNotValid'
          );
        }
        return null;
      default:
        return null;
    }
  }

  ngOnDestroy(): void {
    this.subs.map((subs) => subs.unsubscribe());
  }
}
